"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _immutable = require("immutable");

var _fluxActions = require("flux-actions");

var _actions = require("./actions");

var _mergeWithCollectionOfType = _interopRequireDefault(require("settings-ui-sdk/utils/mergeWithCollectionOfType"));

var _User = _interopRequireDefault(require("./User"));

var initialState = (0, _immutable.Map)({
  users: (0, _immutable.Map)(),
  roles: (0, _immutable.List)(),
  teams: (0, _immutable.Map)()
});

var _default = (0, _fluxActions.handleActions)((0, _defineProperty2.default)({}, _actions.FetchPayloadActionTypes.SUCCESS, function (state, action) {
  return (0, _immutable.fromJS)(action.payload.data).set('teams', action.payload.data.teams.reduce(function (teamsMap, team) {
    return teamsMap.set(team.id, team);
  }, (0, _immutable.Map)())).set('users', (0, _mergeWithCollectionOfType.default)(_User.default, action.payload.data.users, state.get('users')));
}), initialState);

exports.default = _default;
module.exports = exports.default;